module.exports = __webpack_public_path__ + "static/media/termopary7ru.cea150c8.pdf";